module.exports = __webpack_public_path__ + "static/media/CommoditiesHealthFood.80e2cac9.jpg";